'use strict';

import angular from 'angular';

export default angular.module('storageApp.filters.characteristic', [])
  .filter('renderCharacteristic', function(Storage, $sce){
    'ngInject';

    var getCatById = function(id){
      return Storage.getCategories()
        .filter(category => {
          return id == category._id;
        }).shift();
    };

    var getFullPath = function(category) {
      var names = [];

      while(category){
        names.push(category.name);
        category = getCatById(category.parentId);
      }

      return names.reverse().join('/');
    };

    var getCatPath = function(id){
      var category = getCatById(id);
      
      if( ! category){
        return;
      }

      return getFullPath(category);
    };

    var getById = function(id){
      return Storage.getCharacteristics()
        .filter(characteristic => {
          return id == characteristic._id;
        }).shift();
    };

    return function (input, raw) {
      var characteristic = getById(input);
      
      if( ! characteristic){
        return;
      }

      var fullPath = getCatPath(characteristic.categoryId) + '/' + characteristic.name + ' (' + [characteristic.abbreviation, characteristic.em].filter(x => x).join(',') + ')';

      if(raw){
        return fullPath;
      }


      return $sce.trustAsHtml('<span title="' + fullPath + '">' + characteristic.name + '</span>');
    };
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/filters/characteristic.js